import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

import { UserClientsComponent } from "./userclients.component";

import { UserClientsRoutingModule } from "./userclient-routing.module";
import { EmployeeinfohdrService } from "../shell/forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service";
import { GuardianinfoService } from "../shell/forms/school-management/Admission/guardianinfo/guardianinfo.service";
import { ComponentModule } from "../components/component.module";
import { InstituteService } from "../shell/forms/organizational-setup/setup/institute/institute.service";
import { SystemPolicyService } from "../shell/forms/organizational-setup/setup/systempolicy/systempolicy.service";
import { ImageService } from "../shell/shared/image.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UserClientsRoutingModule,
    ComponentModule
  ],
  declarations: [UserClientsComponent],
  providers: [
    InstituteService,
    SystemPolicyService,
    EmployeeinfohdrService,
    ImageService
  ]
})
export class UserClientsModule {}



// WEBPACK FOOTER //
// ./src/app/userclients/userclients.module.ts